/**
 * GraphQL Query that fetches products using received search term and the params
 * for filter, sort and pagination.
 */
export const getProductSearchQuery = (isBy = false) => `
  query SearchProducts($search: String = "", $filters: [Filters] = [], $sort: String) {
    SearchProducts(search: $search, filters: $filters, sort: $sort) {
      zeroQueries
      success
      redirect_url
      count
      ${isBy ? 'sts { st }' : ''}
      header_block {
        content
        show
      }
      categories {
        id
        name
        link_url
        count
      }
      filters {
        dataType
        name
        ${isBy ? 'code' : ''}
        values {
          id
          name
          value
        }
      }
      products {
        id
        sku
        available
        name
        link_url
        image_url
        hover_url
        price
        oldPrice
        badge
        need_preposition
        score
        type
      }
    }
  }
`;

export default getProductSearchQuery();
